import { HpTab } from './types';

export const ACCEPTED_DOC_EXTENSIONS = ['.pdf', '.doc', '.docx', '.ppt', '.pptx'];
export const MAX_DOC_SIZE_BYTES = 25 * 1024 * 1024; // 25 MB

export const TABS: { key: HpTab; label: string }[] = [
  { key: 'banners',   label: 'Banners' },
  { key: 'training',  label: 'EHS & FSQ Training Essentials' },
  { key: 'events',    label: 'Upcoming Events' },
  { key: 'links',     label: 'External Links' },
  { key: 'changelog', label: 'Change Log' },
];

export const ADD_LABELS: Record<HpTab, string> = {
  banners:   'Add New Banner',
  changelog: 'Add New Log',
  events:    'Add New Event',
  training:  'Add New Topic',
  links:     'Add New Link',
};
